import { render, staticRenderFns } from "./BalancesPlanDetailsDelete.vue?vue&type=template&id=44a8b17a&scoped=true&"
import script from "./BalancesPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8b17a",
  null
  
)

export default component.exports